import React, {useEffect, useState} from "react";
import "./App.css";
import {Route, Switch, useHistory} from "react-router-dom";
import Routes from "../routing/Routes";

import {
    MainLoader,
    setAlert,
    darkTheme,
    theme,
    AuthActions,
    AuthGState,
    Footer,
    Navbar,
    getAllOrgsIdsForUserByServiceName,
    useFavoriteTheme,
    Mui,
    MuiIcons,
    ADTE_LOGO_SMALL_URL,
} from "@leap4/frontend";
import {useLocation} from "react-router-dom";
import {ConnectedProps, useDispatch} from "react-redux";
import {connect} from "react-redux";
import {
    BACKEND_SERVICE_NAME,
    logoutUrl,
    meMultiUrl,
    requiredAuthRoles,
} from "../../config/generals";
import {RootState} from "../../interfaces/root-state.interface";
import {urlService} from "../routing/urlsService";
import {QueryClient, QueryClientProvider} from "react-query";
import {setIsLoading} from "../../store/actions/dateRange.actions";
import {emptyUserView, UserViewsContext} from "../../contexts/userViewsContext";

const {CssBaseline, ThemeProvider, Box} = Mui;
const {Logout} = MuiIcons;


const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});

const mapActions = {
    setIsLoading,
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;


interface IProps extends PropsFromRedux {
    history: History,
    auth: AuthGState
}

const queryClient = new QueryClient();

const App = ({auth, setAlert}: IProps) => {
    const history = useHistory();
    const [selectedTheme, setSelectedTheme] = useFavoriteTheme()
    const location = useLocation();
    const dispatch = useDispatch();
    const [bIsSidebarOpen, SetSideBarOpenState] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [currentUserId, setCurrentUserId] = useState('')
    const [userViews, setUserViews] = useState({
        userViewsPresets: [emptyUserView],
        activePreset: emptyUserView
    })
    const nSidebarWidth = 240;

    const getUserOrganizations = () => {
        const userOrgs = getAllOrgsIdsForUserByServiceName(auth.user, auth.user.organizations as string[], requiredAuthRoles, BACKEND_SERVICE_NAME)
        return userOrgs;

    }

    const handleThemeChange = (checked) => {
        const themeToShow = checked ? darkTheme : theme;
        setSelectedTheme(themeToShow)
    }
    useEffect(() => {
        (async () => {
                try {
                    await AuthActions.loadUser(dispatch, BACKEND_SERVICE_NAME, meMultiUrl)
                } finally {
                    setIsLoading(false)
                }
            }
        )();
    }, []);

    useEffect(()=>{
        if(auth.user){
            if(auth.user._id !== currentUserId) setCurrentUserId(auth.user._id)
        }
    },[auth])

    const navbarLinks = [
        {text: "Organizations", link: urlService.organizations()},
        {text: "Users", link: urlService.users()},
        {text: "Publisher Logins", link: urlService.publisherLogins()},
        {text: "Ownerships", link: urlService.ownerships()},
    ]

    if (isLoading) {
        return <MainLoader/>
    }


    return (
        <>
            <ThemeProvider theme={selectedTheme}>
                <QueryClientProvider client={queryClient}>
                    <UserViewsContext.Provider value={{userViews, setUserViews}}>
                    <Box sx={{ display: "flex", flexDirection: 'column' as const, minHeight: '100vh' }}>
                        <CssBaseline/>

                        {auth?.user && <Navbar
                            bIsSidebarOpen={bIsSidebarOpen}
                            handleDrawerClose={() => SetSideBarOpenState(false)}
                            handleDrawerOpen={() => SetSideBarOpenState(true)}
                            auth={{isAuthenticated: true}} ui={{nSidebarWidth, nNavbarHeight: 78}}
                            location={location.pathname} links={navbarLinks}
                            orgsWithPermssions={getUserOrganizations()}
                            updateCheckedToFather={(checked) => {
                                handleThemeChange(checked)
                            }}
                            title={'XPM'} logoImageUrl={ADTE_LOGO_SMALL_URL}
                            logout={{
                                text: "Logout",
                                action: async () => await AuthActions.logout(dispatch, history, logoutUrl),
                                icon: <Logout/>
                            }}
                        />}


                        <Box component="main" sx={{ flexGrow: 1, width: "100%", margin: "auto", pt: '20px' }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}/>
                            <Switch>
                                <Route component={Routes}/>{" "}
                            </Switch>
                        </Box>
                        <Footer text={'XPM'}
                                logoUrl={ADTE_LOGO_SMALL_URL}/>
                    </Box>
            </UserViewsContext.Provider>
                </QueryClientProvider>
            </ThemeProvider>

        </>
    );
};


export default connector(App);
